import {Injectable, OnDestroy} from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { BaseComponent } from './base-component';

const noop = () => {};

@Injectable()
export class BaseValueAccessorComponent extends BaseComponent implements OnDestroy, ControlValueAccessor {
    protected onChangeCallback: (_: any) => void = noop;
    protected onTouchedCallback: () => void = noop;

    writeValue(value: any): void { }

    registerOnChange(fn: (value: any) => void): void {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouchedCallback = fn;
    }

    setDisabledState(isDisabled: boolean): void {}
}
